import { Box, StaticField } from "@intech/web-ui";
import styled from "styled-components";

export const FolhaTitle = styled.h2`
  text-align: center;
  margin: 4px 0;
`;

export const FolhaHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin: 5px 0;
  font-weight: bold;
  font-size: 17px;
`;

export const HeaderProvDesc = styled.div`
  display: flex;
  padding: 0px 25px 0px 10px;
  align-items: center;
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex: 1;
  padding: 5px;
`;

export const HeaderValor = styled.div`
  display: flex;
  padding: 5px;
  font-size: 16px;
  font-weight: bold;
`;

export const BoxFolha = styled(Box)`
  color: #7c7e80;
`;